RivalIQ.apps.Reports.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    widgets.FiletypeFilter = Marionette.ItemView.mixin({
        template: '#reportsFiletypeFilterTemplate',
        tagName: 'span',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        behaviors: {
            DropdownSelector: {
                initialTrigger: true
            }
        },

        onSelectDropdown: function (data) {
            const me = this;
            me.setProps('filetype', data.filetypeId);
        },

        templateHelpers: function () {
            return {
                filetypes: RivalIQ.export.data.filetypes.toJSON()
            };
        }
    });
});
